import {ConfigProvider} from "antd";
import cs_CZ from "antd/es/locale/cs_CZ";
import en_US from "antd/es/locale/en_US";
import {useObserver} from "mobx-react-lite";
import React, {useContext, useEffect} from 'react';
import {RawIntlProvider} from "react-intl";
import HomePage from "./components/homepage/HomePage";
import {AppContextContext} from "./Contexts";
import {createAppIntl} from "./Intl";
import {useMediaQuery} from "react-responsive";
import {routes} from "./components/Routes";
import {useRoutes} from "react-router-dom";

function App() {
    const appContext = useContext(AppContextContext);
    const isTabletOrMobile = useMediaQuery({query: '(max-width: 1224px)'})

    const isPublicRequest = window.location.pathname.startsWith("/fido/auth-request/") || window.location.pathname.startsWith("/register/");

    const route = useRoutes(routes);

    useEffect(() => {
        appContext.isTabletOrMobile = isTabletOrMobile;
    }, [isTabletOrMobile]);

    useEffect(() => {
        if (appContext.user === undefined && !isPublicRequest) {
            document.cookie = `User-Original-URI=${window.btoa(window.location.href)}; path=/`;

            window.location.replace("/api/user/oidc/initiate");
        }
    }, [appContext.user]);

    return useObserver(() => (
        <>
            <RawIntlProvider value={createAppIntl(appContext.language)}>
                <ConfigProvider locale={(appContext.language === 'cs') ? cs_CZ : en_US}
                                theme={{
                                    token: {
                                        borderRadius: 2,
                                        controlHeightLG: 48,
                                        fontFamily: "'Open Sans', sans-serif",
                                        fontSize: 13,
                                        lineHeight: 1.5,
                                        colorPrimary: "#0583FF",
                                        colorText: "rgba(0, 0, 0, 0.65)",
                                        colorBgLayout: "#e9ebf3",
                                        colorBgContainer: "#fff",
                                    },
                                    components: {
                                        Layout: {
                                            headerBg: "#fff",
                                            bodyBg: "#e9ebf3",
                                            siderBg: "#333343",
                                            triggerBg: "#333343",
                                        },
                                        Menu: {
                                            darkItemBg: "#333343",
                                            darkSubMenuItemBg: "#2c2c3a",
                                            darkItemColor: "rgba(255, 255, 255, 0.65)",
                                            darkItemHoverColor: "#fff",
                                            darkItemSelectedColor: "#fff",
                                            darkItemSelectedBg: "#0583FF",
                                            itemBorderRadius: 0,
                                            itemMarginBlock: 0,
                                            itemMarginInline: 0,
                                            iconSize: 22,
                                            collapsedIconSize: 22,
                                        },
                                        Card: {
                                            borderRadiusLG: 0,
                                            colorTextHeading: "#434656",
                                        },
                                        Table: {
                                            bodySortBg: "#fff",
                                            rowExpandedBg: "rgba(0, 0, 0, 0.02)",
                                            headerBg: "#515165",
                                            headerColor: "#fff",
                                            headerSortActiveBg: "#515165",
                                            headerSortHoverBg: "#515165",
                                        },
                                    },
                                }}>
                    {
                        appContext.isTabletOrMobile !== undefined &&

                        <div className="App">
                            {isPublicRequest && route}

                            {!isPublicRequest && appContext.user && <HomePage/>}
                        </div>
                    }
                </ConfigProvider>
            </RawIntlProvider>

            <div className={(appContext.overlayVisible) ? "overlay overlay-visible" : "overlay"}/>
        </>
    ));
}

export default App;
